import { render } from "./TestIntro.vue?vue&type=template&id=703f7a8f"
import script from "./TestIntro.vue?vue&type=script&lang=js"
export * from "./TestIntro.vue?vue&type=script&lang=js"

import exportComponent from "/home/metabrain/withyou/djvue/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__